export const POST_CANCEL_APPOINTMENT_REQUEST='cancelAppointmentReducer/POST_CANCEL_APPOINTMENT_REQUEST'
export const POST_CANCEL_APPOINTMENT_SUCCESS='cancelAppointmentReducer/POST_CANCEL_APPOINTMENT_SUCCESS'
export const POST_CANCEL_APPOINTMENT_FAILED='cancelAppointmentReducer/POST_CANCEL_APPOINTMENT_FAILED'